import { render, staticRenderFns } from "./offer-dialog.vue?vue&type=template&id=2dd5f3ae"
import script from "./offer-dialog.vue?vue&type=script&lang=js"
export * from "./offer-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports